export default __webpack_public_path__ + "static/fmg_logo.png";